/*
 * eComID size alert (bracketing alert) z-index fix
 *
 * The cart drawer (.cart-drawer-modal.cc-popup) has z-index 100000000, while the eComID alert
 * overlay defaults to 100000, so the alert ends up hidden behind the drawer after add to cart.
 * eComID supports a styles.overlay.zIndex prop, but the app block doesn't expose it, so set it here.
 */
(function () {
  var ALERT_Z_INDEX = 100000001;

  function patchBracketingAlert() {
    var alerts = window.ecomid && window.ecomid.alerts;
    if (!alerts || !alerts.bracketingAlert || alerts.bracketingAlert.__zIndexPatched) {
      return;
    }

    var originalInit = alerts.bracketingAlert.init;
    alerts.bracketingAlert.init = function (target, props) {
      if (props) {
        var styles = props.styles || {};
        props.styles = Object.assign({}, styles, {
          overlay: Object.assign({}, styles.overlay, { zIndex: ALERT_Z_INDEX })
        });
      }
      return originalInit.apply(this, arguments);
    };
    alerts.bracketingAlert.__zIndexPatched = true;
  }

  // eComID's loader is a module script, which has executed by DOMContentLoaded
  document.addEventListener('DOMContentLoaded', patchBracketingAlert);
  window.addEventListener('load', patchBracketingAlert);
})();
